import { render } from "./IndexAchat.vue?vue&type=template&id=648e9b90"
import script from "./IndexAchat.vue?vue&type=script&lang=js"
export * from "./IndexAchat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__